import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  updatedData: any = [];
  productobj: any = {};
  constructor() {}

  updateData(data: any) {
    this.updatedData = [];
    switch (data.type) {
      case 'iepd': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            iepd:
              this.addZero(data.event.year) +
              '-' +
              this.addZero(data.event.month) +
              '-' +
              this.addZero(data.event.day),
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          );
          this.productobj['iepd'] =
            this.addZero(data.event.year) +
            '-' +
            this.addZero(data.event.month) +
            '-' +
            this.addZero(data.event.day);
        }

        break;
      }

      case 'iedd': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            iedd:
              data.event.year + '-' + data.event.month + '-' + data.event.day,
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          ); //this.getProductObj(data.productId,this.updatedData);
          this.productobj['iedd'] =
            data.event.year + '-' + data.event.month + '-' + data.event.day;
        }

        break;
      }

      case 'publishingDate': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            publishingDate:
              data.event.year +
              '-' +
              this.addZero(data.event.month) +
              '-' +
              this.addZero(data.event.day),
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          ); //this.getProductObj(data.productId,this.updatedData);
          this.productobj['publishingDate'] =
            data.event.year +
            '-' +
            this.addZero(data.event.month) +
            '-' +
            this.addZero(data.event.day);
        }

        break;
      }

      case 'ppd': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            ppd:
              data.event.year +
              '-' +
              this.addZero(data.event.month) +
              '-' +
              this.addZero(data.event.day),
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          ); //this.getProductObj(data.productId,this.updatedData);
          this.productobj['ppd'] =
            data.event.year +
            '-' +
            this.addZero(data.event.month) +
            '-' +
            this.addZero(data.event.day);
        }

        break;
      }

      case 'epd': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            epd:
              this.addZero(data.event.year) +
              '-' +
              this.addZero(data.event.month) +
              '-' +
              this.addZero(data.event.day),
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          );
          this.productobj['epd'] =
            this.addZero(data.event.year) +
            '-' +
            this.addZero(data.event.month) +
            '-' +
            this.addZero(data.event.day);
        }

        break;
      }

      case 'status': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            status: data.selectedStatusId,
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          );
          this.productobj['status'] = data.selectedStatusId;
        }

        break;
      }

      case 'pistatus': {
        if (!this.productIdExists(data.productId, this.updatedData)) {
          this.productobj = {
            id: data.productId,
            pistatus: data.selectedPiStatus,
          };
          this.updatedData.push(this.productobj);
        } else {
          this.productobj = this.updatedData.find(
            (product: any) => product.id == data.productId
          );
          this.productobj['pistatus'] = data.selectedPiStatus;
        }

        break;
      }
    }

    return this.updatedData;
  }

  productIdExists(id: string, arr: any) {
    return arr.some(function (el: any) {
      return el.id === id;
    });
  }

  addZero(val: number) {
    if (val < 10) return '0' + val;

    return val;
  }
}
